import React, { useState } from 'react';

const ProgressBar = ({ percentage }) => {
  const containerStyle = {
    width: '100%',

    background: '#ccc',
    height: '40px',
    borderRadius: '10px', // Rounded corners
    position: 'relative',
  };

  const fillStyle = {
    width: `${percentage}%`,
    height: '100%',
    background: 'green',
    borderRadius: '10px', // Rounded corners
    position: 'absolute',
    transition: 'width 0.5s', // Smooth animation
  };

  const labelStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: 'white',
  };

  return (
    <div style={containerStyle}>
      <div style={fillStyle}>
        <div style={labelStyle}>{`${percentage}%`}</div>
      </div>
    </div>
  );
};
export default ProgressBar